import styled from 'styled-components';

export const HotelSearchWrapper = styled.div<{ cyprus?: boolean }>`
  .react-tiny-popover-container {
    width: ${({ cyprus }) => (cyprus ? '686px' : '570px')}!important;
    top: -10px !important;
  }
`;
